module.exports = __webpack_public_path__ + "img/2.00553890.png";